import {
  getGridSingleSelectOperators,
  getGridStringOperators,
} from '@mui/x-data-grid'

const FILTER_OPERATORS_BY_TYPE = {
  default: ['contains', 'equals', 'startsWith'],
  date: ['is', 'isNot', 'isAfter', 'isBefore'],
  datetime: ['is', 'isNot', 'isAfter', 'isBefore'],
  boolean: ['is'],
  number: ['=', '!=', '>', '<'],
  array: ['isAnyOf'],
}

export const getFilterOperators = (fieldType, isSingle = false) => {
  const gridOperators = isSingle
    ? getGridSingleSelectOperators()
    : getGridStringOperators()
  const allowed =
    FILTER_OPERATORS_BY_TYPE[fieldType] ?? FILTER_OPERATORS_BY_TYPE.default
  return gridOperators.filter(({ value }) => allowed.includes(value))
}
